import { getPasswordStrengthChecks } from "./passwordStrength";

export default function PasswordStrengthChecklist({ password = "", className = "" }) {
  const checks = getPasswordStrengthChecks(password);
  const classNames = ["password-strength-checklist", className]
    .filter(Boolean)
    .join(" ");

  return (
    <ul className={classNames} aria-label="Requisitos da senha">
      {checks.map((check) => (
        <li
          key={check.id}
          className={
            check.passed
              ? "password-strength-checklist__item password-strength-checklist__item--passed"
              : "password-strength-checklist__item"
          }
        >
          <span className="password-strength-checklist__marker" aria-hidden="true" />
          <span>{check.label}</span>
        </li>
      ))}
    </ul>
  );
}
